/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


import ScrollMagic from 'ScrollMagic';
import animationGSAP from 'animation.gsap';
import addIndicators from 'debug.addIndicators';
import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      // Grab all elements to be animated and apply the appropriate animation class
      const animationController = new ScrollMagic.Controller( {globalSceneOptions: {triggerHook: 0.90}} );
      const controller = new ScrollMagic.Controller();
      // build scenes
      $( '.js-animate-col, .js-animate-up, .js-animate-down, .js-animate-right' ).each( function() {
        new ScrollMagic.Scene( {triggerElement: this} )
            .setClassToggle( this, 'js-animated' ) // add class toggle
            .addTo( animationController );
      } );

      $( '.block--dark' ).each( function() {
        new ScrollMagic.Scene( {triggerHook: 0.15, triggerElement: this, duration: $( this ).outerHeight()} )
            .setClassToggle( '.navbar-toggle', 'text-white' ) // add class toggle
            .addTo( controller );
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'global-animation', COMPONENT );
} )( app );
